module.exports = __webpack_public_path__ + "img/sw_steakhouse_wynn_palace.8b78980a.jpg";